import barba from '@barba/core';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import throttle from 'lodash.throttle';

import views from '../views/views';
import transitions from '../transitions/transitions';

export default class Barba {
	constructor() {
		this.domparser = new DOMParser();

		document.addEventListener(
			'scroll',
			throttle((e) => this.checkScroll(), 100)
		);
		this.checkScroll();

		// Zorgt ervoor dat de scroll positie niet onthouden wordt
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.before(({ current, next, trigger }) => {
			window.dispatchEvent(new CustomEvent('disable-scroll'));
		});

		// Global Barba hooks
		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const triggers = ScrollTrigger.getAll();
			triggers.forEach((trigger) => {
				trigger.kill();

				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				trigger.scroll.rec = null;
				const lelijk = setInterval(() => {
					if (trigger.scroll.rec !== null) {
						trigger.scroll.rec = null;
						//console.log("haha toch niet!");
					}
				}, 10);
			});

			window.dispatchEvent(new CustomEvent('scroll-to-top'));

			const blessEvent = new CustomEvent('bless', {
				detail: {
					element: next.container,
					trigger: trigger,
				},
			});
			document.dispatchEvent(blessEvent);
		});

		barba.hooks.afterEnter(({ current, next, trigger }) => {
			window.dispatchEvent(new CustomEvent('enable-scroll'));

			const afterEnterEvent = new CustomEvent('afterEnter', {
				detail: {
					next,
				},
			});

			document.dispatchEvent(afterEnterEvent);
		});

		barba.hooks.after(({ current, next, trigger }) => {
			window.dispatchEvent(new CustomEvent('refresh-scroll'));

			// Execute scripts after transition
			// Onderstaande code is 'overgenomen' uit de september cookie consent plugin
			const scriptElements = next.container.querySelectorAll('script');
			scriptElements.forEach((element) => {
				let src = '';
				if ((src = element.getAttribute('src'))) {
					const script = document.createElement('script');
					script.type = 'text/javascript';
					script.setAttribute('src', src);
					element.parentElement.appendChild(script);
				} else {
					//TODO: bless
					const html = element.innerHTML;
					element.insertAdjacentHTML('afterend', html);
					element.remove();
				}
			});

			this.track();
			this.removeMetaFromHead();
			const page = this.domparser.parseFromString(next.html, 'text/html');
			this.addMetaToHead(page);
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			current.container.dispatchEvent(new CustomEvent('unbless', { bubbles: true }));
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				const url = new URL(href);

				if (!url) {
					return false;
				}

				//prevent external links
				if (url.hostname !== window.location.hostname) {
					return true;
				}

				//prevent if not a /-link
				if (!url.pathname.endsWith('/')) {
					return true;
				}

				return false;
			},
			views,
			transitions,
		});
	}

	checkScroll() {
		// Only for Non Locomotive Scroll (mobile/touch)
		window.scrollY > 20 ? this.stick() : this.unStick();
		this.prevScroll = window.scrollY;
	}

	stick() {
		// Only for Non Locomotive Scroll (mobile/touch)
		document.body.classList.add('has-scrolled');
		if (this.prevScroll > window.scrollY) {
			document.body.classList.add('has-scrolled-up');
			document.body.classList.remove('has-scrolled-down');
		} else {
			document.body.classList.add('has-scrolled-down');
			document.body.classList.remove('has-scrolled-up');
		}
	}

	unStick() {
		// Only for Non Locomotive Scroll (mobile/touch)
		document.body.classList.remove('has-scrolled');
	}

	track() {
		if (window.WPURLS.env !== 'production') {
			return;
		}

		dataLayer.push({
			event: 'page_view',
			page: {
				page_path: window.location.pathname,
			},
		});

		// Als bovenstaande push van event 'page_view' niet werkt kan onderstaande geprobeerd worden
		// dataLayer.push({
		// 	'event':'virtualPageView',
		// 	'page':{
		// 		'title':document.title,
		// 		'url':window.location.pathname
		// 	}
		// });
	}

	removeMetaFromHead() {
		const metaTags = document.querySelectorAll('head meta[property], head .yoast-schema-graph');

		metaTags.forEach((metaTag) => metaTag.remove());
	}

	addMetaToHead(page) {
		try {
			const metaTags = page.querySelectorAll('head meta[property], head .yoast-schema-graph');

			document.head.append(...metaTags);
		} catch {
			console.error('Updating head failed...');
		}
	}
}
